function initializeRunningText() {
  var runningText = document.querySelector('.running-text__grid .swiper-container');

  if (!runningText) {
    return;
  }

  var swiperRunningText = new Swiper(runningText, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    speed: 5000,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
      1024: {
        spaceBetween: 60,
      },
    },
  });

  if (Shopify.designMode) {
    runningText.addEventListener('mouseenter', function () {
      swiperRunningText.autoplay.stop();
    });

    runningText.addEventListener('mouseleave', function () {
      swiperRunningText.autoplay.start();
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initializeRunningText();
});
